import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

sentry.init({
  dsn: environment.sentryDSN,
  environment: environment.production ? 'production' : 'development',
  integrations: [
    sentry.browserTracingIntegration(),
    sentry.replayIntegration(),
  ],
  tracePropagationTargets: [
    environment.teacherAPI,
    environment.authAPI,
    environment.licenseAPI,
    environment.materialAPI,
    environment.menuAPI,
    environment.materialServer,
    environment.dadApplicationUrl,
    environment.pdfApiBase,
  ],
  // Performance Monitoring
  tracesSampleRate: environment.tracesSampleRate ?? 0,
  // Session Replay
  replaysSessionSampleRate: environment.replaysSampleRate ?? 0,
  replaysOnErrorSampleRate: environment.replaysSampleRate ?? 0,
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
